<template>
  <div class="wrap">
    <div style="text-align: left;padding: 20px 20px;position: absolute;z-index: 99;"><van-icon name="arrow-left" size="30px" color="#000" @click="goBack" /></div>
    <div class="container">
      <van-swipe :autoplay="autoplay" indicator-color="#DD8560">
        <van-swipe-item v-if="goods_info.video">
            <div class="video_wrap">
                <video id="vide" playsinline="true" x-webkit-airplay="true" x5-playsinline="true"
                      webkit-playsinline="true" x5-video-player-type="h5" controls :poster="goods_info.images">
                    <source
                        :src="goods_info.video"
                        type="video/mp4">
                </video>
                <div @click="play_video" class="video_laye" v-show="ia_apple">
                    <van-icon name="play-circle-o"/>
                </div>
            </div>
        </van-swipe-item>
        <van-swipe-item v-for="(image, index) in goods_info.photo" :key="index">
            <img width="100%" v-lazy="image.images"/>
            <div class="diszk" v-if="goods_info.discount_show_text > 0">
                <p>{{ goods_info.discount_show_text }}%</p>
                <p>OFF</p>
            </div>
        </van-swipe-item>
      </van-swipe>
      <div style="padding: 0 19px;margin: 10px 0 20px;">
        <div class="details_info" style="padding: 0;">
          <div class="details_titile van-multi-ellipsis--l2">{{ goods_info.title }}</div>
        </div>
        <div class="title_price">
          <span style="font-size: 15px;font-weight: 100;margin-right: 6px;color: #14142B;">¥</span>{{ goods_info.min_price }}
          <span class="sold_box">已售 <span style="font-size: 15px;font-weight: 600;">{{ sold }}+</span></span>
        </div>
        <div class="tag_box"><van-icon name="logistics" size="13px" color="#747474" style="margin-right: 8px;" />预计24小时内发货 多仓发货 快递：免运费</div>
        <div class="tag_box"><van-icon name="like-o" size="13px" color="#747474" style="margin-right: 8px;" />假一赔四 7天无理由退换</div>
      </div>
      
      
      <div class="details_img">
        <div
          class="ds12"
          style="line-height: 1.5; padding: 0 19px"
          v-html="goods_info.content_web"
        ></div>
      </div>
      <div class="goods_action f-clearfix">
        <van-goods-action safe-area-inset-bottom class="goods_action_box">
          <div class="price-section">
            <div class="price-label">活动价：</div>
            <div class="price-value"><span class="currency">¥</span>{{ goods_info.min_price }}</div>
          </div>
          <van-goods-action-button
            class="buy-button"
            color="#000000"
            type="danger"
            text="加入购物袋"
            @click="showsuk('cart')"
          />
        </van-goods-action>
      </div>
      <van-sku
        v-model="skushow"
        :sku="sku"
        :initial-sku="initialSku"
        :goods="goods"
        :goods-id="goods_id"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
        ref="getSku"
        :quota="Number(goods_info.buy_max_number)"
        :start-sale-num="Number(goods_info.buy_min_number)"
        class="sku-container"
      >
        <template #sku-header-price="props">
          <div style="color: #14142B;margin-bottom: 14px;width: 94%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;">{{ goods_info.title }}</div>
          <div class="van-sku__goods-price" style="margin-bottom: 8px;">
            <span class="van-sku__price-symbol">￥</span>
            <span class="van-sku__price-num" style="color: #FD4418;margin-left: 3px;">{{ props.price }}</span>
          </div>
          
        </template>
      
        <template #sku-actions="props">
          <!-- <div style="display: flex;justify-content: space-between;height: 40px;flex-direction: column;margin: 0 0 25% 9%;font-size: 14px;color: #14142B;">
            <div>价格说明 ></div>
            <div>发货后7天无理由退换</div>
          </div> -->
          <!-- <div class="van-sku-actions"> -->
            <!-- <div class="goods_action f-clearfix"> -->
              <van-goods-action safe-area-inset-bottom class="goods_action_box1">
                <div class="price-section">
                  <div class="price-label">活动价：</div>
                  <div class="price-value"><span class="currency">¥</span>{{ goods_info.min_price }}</div>
                </div>
                <van-goods-action-button
                  class="buy-button"
                  color="#000000"
                  type="danger"
                  text="加入购物袋"
                  @click="checkLoginAndBuy(props)"
                />
              </van-goods-action>
            <!-- </div> -->
             
            <!-- <van-button
              square
              size="large"
              type="danger"
              color="#E83AAE"
              @click="props.skuEventBus.$emit('sku:buy')"
            >
              确定
            </van-button> -->
          <!-- </div> -->
        </template>
      </van-sku>
      <!-- select goods spec end-->
    </div>
    <v-foot></v-foot>
  </div>
</template>
<style scoped>
.video_wrap {
  width: 100%;
  position: relative;
}

.video_wrap video {
  width: 100%;
}

.video_wrap .video_laye {
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video_wrap .video_laye .van-icon-play-circle-o {
  font-size: 5em;
  color: #fff;
}
.van-sku-actions{
  position: relative;
}
.goods_action_box {
  bottom: 2%;
  width: 83%;
  margin: 0 auto;
  background: #14142B;
  border-radius: 50px;
  padding: 4px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 16px rgb(255 255 255 / 30%);
}
.goods_action_box1 {
  position: absolute;
  bottom: 5%;
  left: 6.2%;
  width: 87%;
  /* margin: 0 auto; */
  background: #14142B;
  border-radius: 50px;
  padding: 4px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 16px rgb(255 255 255 / 30%);
}
.price-section {
  width: 41%;
  color: #fff;
  margin-left: 23px;
  border-radius: 50px;
}

.price-label {
  font-size: 12px;
  margin-bottom: 3px;
  color: rgba(255, 255, 255, 0.7);
}

.price-value {
  font-size: 18px;
  font-weight: normal;
}

.currency {
  font-size: 13px;
  margin-right: 4px;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.7);
}

.buy-button {
  border-radius: 25px !important;
  height: 43px !important;
  font-size: 13px !important;
  font-weight: normal !important;
  /* padding: 0 10px !important; */
}

:deep(.van-goods-action-button) {
  --van-button-danger-background: #DD8560 !important;
  --van-button-danger-border-color: #DD8560 !important;
}

:deep(.van-sku-stepper-stock) {
  display: flex;
  flex-direction: column;
}

:deep(.van-sku__stepper) {
  margin-top: 12px;
}
:deep(.van-sku-row__item) {
  /* border: 1px solid #9E9E9E; */
  border-radius: 0;
  font-weight: bold;
  min-width: 60px;
  /* font-size: 18px; */
}
:deep(.van-sku-row__item--active::before, .van-sku-row__image-item--active::before) {
    border: none;
    background: #000000;
    opacity: 1;
}
:deep(.van-sku-row__item--active,.van-sku-row__item-name){
  color: #fff;
}
/* :deep(.van-sku-row__item::before,.van-sku-row__item-name){
  color: #000 !important;
} */
:deep(.van-popup--bottom.van-popup--round){
  border-radius: 0;
}
/* :deep(.van-popup--bottom){
  top: 7.7%;
} */
:deep(.van-sku-container){
  min-height: 60%;
  max-height: 66%;
}
:deep(.van-overlay){
  background-color: rgb(0 0 0 / 0%);
}
:deep(.van-sku-header-item){
  display: none;
}
.title_price{
  font-size: 26px;
  font-weight: bold;
  color: #FD4418;
  margin: 10px 0;
}
.tag_box{
  color: #747474;
  font-size: 13px;
  margin-bottom: 6px;
}
.sold_box{
  font-size: 16px;
  font-weight: 100;
  margin-right: 6px;
  color: #14142B;
  font-weight: 500;
  margin-left: 6px;
}
</style>
<script>
var vide;
// @ is an alias to /src

/**
 * 设置本页提示语
 */
import { ImagePreview } from "vant";
import { Locale } from "vant";
// import coupons_boxVue from './coupons_box.vue';
const messages = {
  "zh-CN": {
    vanSku: {
      select: "请选择",
      selected: "已选择",
      selectSku: "请先选择商品规格",
      soldout: "库存不足",
      originPrice: "原价",
      minusTip: "至少选择一个",
      minusStartTip: function minusStartTip(start) {
        return start + "\u0046\u0072\u006f\u006d";
      },
      unavailable: "商品已不再供应",
      stock: "剩余",
      stockUnit: "个",
      quotaTip: function quotaTip(quota) {
        return "\u6BCF\u4EBA\u9650\u8D2D" + quota + "\u4EF6";
      },
      quotaUsedTip: function quotaUsedTip(quota, count) {
        return (
          "\u6BCF\u4EBA\u9650\u8D2D" +
          quota +
          "\u4EF6\uFF0C\u4F60\u5DF2\u8D2D\u4E70" +
          count +
          "\u4EF6"
        );
      },
    },
  },
};
Locale.add(messages);

export default {
  components: {},
  data() {
    return {
      firstshow: true,
      pl_star_show: 5,
      pl_star: 3,
      make_star_1: 0,
      make_star_2: 0,
      make_star_3: 0,
      make_text: "",
      goods_id: 0,
      details_reviews: true,
      common_cart_total: "",
      swip_img: [
        "https://img.yzcdn.cn/vant/cat.jpeg",
        "https://img.yzcdn.cn/vant/cat.jpeg",
      ],
      plshow: false,
      skushow: false,
      gb_overlay: false,
      reviewbox: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: "color", // skuKeyName：规格类目名称
            k_s: "", //s1 skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "", // 1 skuValueId：规格值 id
                name: "", // red skuValueName：规格值名称
                imgUrl: "", // https://img.yzcdn.cn/2.jpg 规格类目图片，只有第一个规格类目可以定义图片
                previewImgUrl: "", // https://img.yzcdn.cn/2p.jpg 用于预览显示的规格类目图片
              },
            ],
            largeImageMode: false, //  是否展示大图模式
          },
          {
            k: "size", // skuKeyName：规格类目名称
            k_s: "", //s2 skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
            v: [
              {
                id: "", // 1 skuValueId：规格值 id
                name: "", //red skuValueName：规格值名称
                imgUrl: "", //https://img.yzcdn.cn/2.jpg 规格类目图片，只有第一个规格类目可以定义图片
                previewImgUrl: "", //https://img.yzcdn.cn/2p.jpg 用于预览显示的规格类目图片
              },
            ],
            largeImageMode: false, //  是否展示大图模式
          },
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          {
            id: 2259, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "1", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "2", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "2", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "1", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
          },
          {
            id: 2259, // skuId
            s1: "2", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "2", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 100, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
          },
        ],
        price: "1.00", // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        hide_stock: true, // 是否隐藏剩余库存
      },
      goods: {
        picture: "",
      },
      goods_info: [],
      sure_type: "",
      reviews: [],
      page: 1,
      loading: false,
      finished: false,
      all_comments: [],
      video: [],
      file_list: [],
      images: [],
      user_info: false,
      ia_apple: false,
      browser: [],
      autoplay: 3000,
      flag: true,
      initialSku: {},
      sold: 0,
    };
  },
  created() {
    this.goods_id = this.$route.query.id;
    this.get_browser();
    this.getData(this.goods_id);
    this.user_info = this.getUserInfo();
    this.sold = Math.floor(Math.random() * (1000 - 500 + 1)) + 500;
  },
  mounted() {
    let url = "api/agreement/maidian?type="+'productDetails'
    this.GET(url,function (ret) {
      if(ret.code === 0){
        console.log('请求成功')
      }
    })
    // console.log(321,this.sku)
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    get_browser() {
      this.browser = {
        versions: (function () {
          var u = navigator.userAgent;
          // var app = navigator.appVersion;
          return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            wechat: u.indexOf("MicroMessenger") > -1, //是否微笑浏览器
          };
        })(),
        language: (
          navigator.browserLanguage || navigator.language
        ).toLowerCase(),
      };
    },
    change_pl: function () {
      this.plshow = !this.plshow;
    },
    showsuk(type) {
      this.sure_type = type;
      this.skushow = true;
    },
    showReview() {
      this.reviewbox = true;
      if (!this.getUserInfo(true)) {
        return;
      }
    },
    getData(id) {
      var url = "/api/goods/Detail";
      var data = { goods_id: id };
      var _self = this;
      this.POST(url, data, function (data) {
        if (data.code == 0) {
          _self.goods_info = data.data.goods;
          _self.pl_star_show = data.data.goods.start;
          _self.sku = data.data.goods.sku;
          _self.initialSku = data.data.goods.sku.list[0];
          _self.goods.picture = data.data.goods.home_recommended_images;
          _self.common_cart_total = data.data.common_cart_total;
          _self.reviews = data.data.reviews;
          if (_self.firstshow) {
            window.fbq("trackCustom", "show_good_info_h5", {
              id: _self.goods_info.id,
            });
            window.gtag("event", "show_good_info_h5", {
              method: "show_good_info_h5",
              content: _self.goods_info.id,
              value: _self.goods_info.id,
              value_goods_id: _self.goods_info.id,
            });
          }
          if (
            _self.browser.versions.ios ||
            _self.browser.versions.iPhone ||
            _self.browser.versions.iPad
          ) {
            _self.ia_apple = true;
          }
        }
      });
    },
    change_view() {
      if (this.details_reviews) {
        this.details_reviews = false;
      } else {
        this.details_reviews = true;
      }
    },
    // onBuyClicked(data){
    // 	if(data.selectedSkuComb === null){
    // 		this.$toast('Please select product specification');
    // 		return false;
    // 	}
    // },
    onAddCartClicked() {},
    /**
     * 加入购物车
     * @returns {boolean}
     */
    onBuyClicked() {
      var _self = this;
      var data = this.$refs.getSku.getSkuData();
      if (data.selectedSkuComb === null) {
        this.$toast("请选择商品规格");
        return false;
      }
      if (this.sure_type == "cart") {
        var post_data_cart = {
          goods_id: data.goodsId,
          stock: data.selectedNum,
          color: data.selectedSkuComb.s1,
          size: data.selectedSkuComb.s2,
        };
        var url_cart = "/api/cart/save";
        this.POST(url_cart, post_data_cart, function (ret) {
          if (ret.code == 0) {
            _self.common_cart_total = ret.data;
            // document.getElementById("cart_total").innerText = ret.data;
            // 检查元素是否存在
            var cartTotalElement = document.getElementById("cart_total");
            if (cartTotalElement) {
              cartTotalElement.innerText = ret.data;
            }
            _self.$toast(ret.msg);
          } else {
            _self.$toast(ret.msg);
          }
          _self.skushow = false;
        });
        window.fbq("trackCustom", "buy_cart_add_h5", { id: data.goodsId });
        window.gtag("event", "buy_cart_add_h5", {
          method: "buy_cart_add_h5",
          content: data.goodsId,
          value: data.goodsId,
          value_goods_id: data.goodsId,
        });
      } else if (this.sure_type == "buy_now") {
        // _self.$toast.loading({
        // 	message: '加载中...',
        // 	forbidClick: true,
        // });
        _self.skushow = false;
        var post_data = {
          goods_id: data.goodsId,
          stock: data.selectedNum,
          color: data.selectedSkuComb.s1,
          size: data.selectedSkuComb.s2,
          buy_type: "goods",
        };

        window.fbq("trackCustom", "add_payment_info_h5", { id: data.goodsId });
        window.gtag("event", "add_payment_info_h5", {
          method: "add_payment_info_h5",
          content: data.goodsId,
          value: data.goodsId,
          value_goods_id: data.goodsId,
        });
        //暂时不用跳登录页面 2020年9月15日10:12:56
        if (this.user_info === false) {
          var u_tmp = this.getUserInfo();
          if (u_tmp == false) {
            localStorage.setItem(
              "buy_now_goods_info_tologin",
              JSON.stringify(post_data)
            );
            setTimeout(function () {
              _self.getUserInfo(true);
            }, 666);
          }
        } else {
          localStorage.setItem("buy_now_goods_info", JSON.stringify(post_data));
          setTimeout(function () {
            _self.$router.push({
              path: "pay",
              query: { ids: data.goodsId, buy_type: "goods" },
            });
          }, 666);
        }
        //    if(this.user_info === false){
        // 		var u_tmp = this.getUserInfo();
        // 		if(u_tmp == false){
        // 			localStorage.setItem('buy_now_goods_info_tologin', JSON.stringify(post_data));
        // 			setTimeout(function(){
        // 				_self.getUserInfo(true);
        // 			},666)
        // 		}
        // 	}else{
        // localStorage.setItem('buy_now_goods_info', JSON.stringify(post_data));
        // setTimeout(function () {
        //     _self.$router.push({path: 'pay', query: {ids: data.goodsId, buy_type: 'goods'}})
        // }, 666)
        // }
      }
    },
    beforeRead(file) {
      if (this.file_list.length === 0) {
        return true;
      }
      for (var i = 0; i < this.file_list.length; i++) {
        if (this.file_list[i].file.type.indexOf("video") != -1) {
          if (file.type.indexOf("video") != -1) {
            this.$toast("您最多只能上传一个视频");
            return false;
          }
        }
      }
      return true;
    },
    afterRead(file) {
      var file_type = file.file.type;
      var _self = this;
      var file_name = file.file.name;
      if (file_type.indexOf("image") == -1) {
        //视频
        var formData = new FormData();
        formData.append("file", file.file);
        var url = "api/goods/uploadVideo";
        this.POST(url, formData, function (ret) {
          if (ret.code === 0) {
            _self.video[file_name] = ret.data.url;
          }
        });
      } else {
        this.images[file_name] = file.content;
      }
    },

    getCommentList() {
      if (this.flag === false) {
        return false;
      }
      this.flag = false;
      var url = "api/goods/comments";
      var data = { page: this.page, goods_id: this.goods_id };
      var _self = this;

      this.loading = true;
      this.POST(url, data, function (ret) {
        _self.flag = true;
        if (ret.code === 0) {
          _self.all_comments = _self.all_comments.concat(ret.data.data);
          _self.finished = !ret.data.next_page;
          _self.page = ret.data.page;
        }
      });
      this.loading = false;
    },

    submitReviews() {
      if (!this.getUserInfo(true)) {
        return false;
      }
      if (this.make_star_1 < 1) {
        this.$toast("请对商品质量进行评分");
        return false;
      }
      if (this.make_star_2 < 1) {
        this.$toast("请对运输速度进行评分");
        return false;
      }
      if (this.make_star_3 < 1) {
        this.$toast("请对客服服务进行评分");
        return false;
      }
      if (this.make_text == "") {
        this.$toast("请填写评价内容");
        return false;
      }
      var url = "api/goods/AddComment";
      var images_temp = [];
      var video_temp = [];
      for (var i = 0; i < this.file_list.length; i++) {
        if (this.images[this.file_list[i].file.name] != undefined) {
          images_temp.push(this.images[this.file_list[i].file.name]);
        }
        if (this.video[this.file_list[i].file.name] != undefined) {
          video_temp = this.video[this.file_list[i].file.name];
        }
      }
      var data = {
        goods_id: this.goods_id,
        rating: Math.ceil(
          (this.make_star_1 + this.make_star_2 + this.make_star_3) / 3
        ),
        rating_total: this.make_star_1 + this.make_star_2 + this.make_star_3,
        content: this.make_text,
        imgs: images_temp,
        id: this.id,
        order_detail_id: this.order_detail_id,
        video: video_temp,
      };
      var _self = this;
      this.POST(url, data, function (ret) {
        if (ret.code === 0) {
          _self.$toast(ret.msg);
          setTimeout(function () {
            window.location.reload();
          }, 500);
        } else {
          _self.$toast(ret.msg);
        }
      });
    },

    showImages(images) {
      ImagePreview({ images, closeable: true });
    },
    toReview() {
      document.getElementById("hair_pl").scrollIntoView();
    },
    play_video() {
      vide = document.getElementById("vide");
      vide.play();
      this.ia_apple = false;
      this.autoplay = 0;
      var _self = this;
      vide.addEventListener("play", function () {
        _self.autoplay = 0;
      });
      //监听播放结束
      vide.addEventListener("pause", function () {
        _self.autoplay = 3000;
      });
      //监听播放结束
      vide.addEventListener("ended", function () {
        _self.autoplay = 3000;
      });
    },
    checkLoginAndBuy(props) {
      if (this.getUserInfo()) {
        // 用户已登录，触发原始事件
        props.skuEventBus.$emit('sku:buy');
      } else {
        // 用户未登录，直接跳转到登录页面
        // 保存当前页面信息，便于登录后返回
        localStorage.setItem('reg_from', this.$route.path);
        this.$router.push('login');
      }
    },
  },
};
</script>
